import React, { ReactNode } from "react";
import { useTheme } from "../../../Hooks";
import { FmIcon } from "../../../Components";

import useStyles from "./Tag.style";

type variant = "standard" | undefined;

interface TagProps {
  onClose: any;
  children: ReactNode;
  variant?: string;
}

const Tag = ({ onClose, variant, children }: TagProps) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <div className={classes.container}>
      <div className={classes.children_container}>{children}</div>
      <div className={classes.icon_container} onClick={onClose}>
        <FmIcon url={theme.images.close} title={"visible"} />
      </div>
    </div>
  );
};

export default Tag;
